module.exports = __webpack_public_path__ + "img/logo.5bdb575c.png";